export default "__VITE_ASSET__66fe8542__"